module.exports = __webpack_public_path__ + "img/preview-photo-review-FIRST_TYPE.fa54d6dd.png";